<template>
  <div>
    <users-list-filters
      :role-filter.sync="roleFilter"
      :group-filter.sync="groupFilter"
      :status-filter.sync="statusFilter"
      :parent-status-filter.sync="parentStatusFilter"
      :role-options="roleOptions"
      :group-options="groupOptions"
      :status-options="statusOptions"
      :parent-status-options="parentStatusOptions"
    />
    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="9"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
          
            <b-button
                variant="primary"
                 class="mr-1"
                size="sm"
                @click="showUserCreate = true"
              >
                <feather-icon icon="PlusIcon"/>
                <span class="text-nowrap">
                  Nieuwe gebruiker toevoegen</span>
              </b-button>
             <!-- <b-button
                variant="primary"
                 class="mr-1"
                size="sm"
                @click="Test"
              >
                <feather-icon icon="PlusIcon"/>
                <span class="text-nowrap">
                  TEST</span>
              </b-button> -->
               <!-- <b-button
                variant="primary"
                 class="mr-1"
                size="sm"
                @click="fixContacts"
              >
              
                <feather-icon icon="PlusIcon"/>
                <span class="text-nowrap">
                  Contacten migreren</span>
              </b-button> -->
              <!-- <b-button
                variant="primary"
                 class="mr-1"
                size="sm"
                @click="fixGroups"
              >Fix deleted groups</b-button> -->
            <b-dropdown
            variant="outline-primary"
            bordered
            class="mr-1 bg-white"
            size="sm"
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              Acties
            </template>
            <b-dropdown-item :disabled="selected.length < 1" @click="moveUsersDialogVisible = true" variant="primary">
              <feather-icon icon="PlusIcon" />
              <span class="align-middle ml-50">{{selected.length}} gebruikers toevoegen aan een groep</span>
            </b-dropdown-item>
            </b-dropdown>
            <m365-dropdown v-if="$store.state.organisation && $store.state.organisation.modules && $store.state.organisation.modules.integrations && $store.state.organisation.modules.integrations.m365" :users="selectedUsers"/>
            <download-dropdown :usersData="usersData" :selectedUsers="selectedUsers"/>
            <advanced-dropdown/>
            

             
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="3">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                size="sm"
                class="d-inline-block mr-1"
                placeholder="Zoeken..."
                @input="refetchData"
              />
              
            </div>
          </b-col>
        </b-row>
      </div>
      

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchUsers"
        responsive
        :fields="tableColumns"
        primary-key="uoid"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Geen gebruikers gevonden"
        :sort-desc.sync="isSortDirDesc"
      >
       <!-- A custom formatted header cell for field 'selected' -->
        <template #head(selected)>
          <b-form-checkbox
            @change="selectAll"
            :checked="selected.length === totalusers"
            :indeterminate="selected.length < totalusers && selected.length > 0"
          ></b-form-checkbox>
        </template>
        <!-- Column: Selected -->
        <template #cell(selected)="data">
          <b-form-checkbox
            name="selected-items"
            v-model="selected"
            :value="data.item.uoid"
          ></b-form-checkbox>
        </template>
        <template #cell(displayName)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.profilePic ? data.item.profilePic.small : null"
                :text="avatarText(data.item.displayName)"
                :variant="`light-${resolveUserRoleVariant(
                  data.item.type ||
                    (data.item.organisations && data.item.organisations[$store.state.organisation.id].type) || 'member'
                )}`"
                :to="{
                  name: 'users-edit',
                  params: { uoid: data.item.uoid },
                }"
              />
            </template>
            <b-link
              :to="{ name: 'users-edit', params: { uoid: data.item.uoid } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.displayName }}
            </b-link>
            <small class="text-muted">{{ data.item.email }}</small>
          </b-media>
        </template>
        <!-- Column: Status -->
        <template #cell(groupIds)="data">
          <div class="d-flex flex-wrap justify-content-start" style="width: 20rem">
            <b-link 
            
            :key="k+data.item.uoid"
              v-for="(g, k) in getGroupsForUser(data.item.uoid)"
              :to="{name: 'group-detail', params: {id: k}}">
            <b-badge
              
              pill
              :style="`background-color: ${getGroupColor(
                $store,
                k
              )}15; color: ${getGroupColor($store, k)}`"
              class="text-capitalize mr-25"
            >
              {{ g.name }}
            </b-badge>
            </b-link>
          </div>
        </template>
        <!-- Column: Role -->
        <template #cell(type)="data">
          <div class="text-nowrap">
            <b-avatar class="mr-50" :variant="`light-${resolveUserRoleVariant(
                data.item.type || (data.item.organisations && 
                  data.item.organisations[$store.state.organisation.id].type) || 'member'
              )}`">
            <feather-icon
              :icon="
                resolveUserRoleIcon(
                  data.item.type ||
                    (data.item.organisations && 
                  data.item.organisations[$store.state.organisation.id].type) || 'member'
                )
              "
              size="18"
              
              :class="`text-${resolveUserRoleVariant(
                data.item.type ||
                  (data.item.organisations && 
                  data.item.organisations[$store.state.organisation.id].type) || 'member'
              )}`"
            />
            </b-avatar>
            <span class="align-text-top text-capitalize">{{
              getRoleSingular(
                data.item.type
              )
            }}</span>
          </div>
        </template>

         <!-- Column: Children -->
        <template #cell(contacts)="data">
          <b-avatar-group v-if="data.item.contacts.length > 0" size="32px">
            <b-avatar
              :key="c"
              v-for="(k, c) in data.item.contacts"
              :to="{ name: 'contacts-edit', params: { id: data.item.contacts[c].id } }"
              v-b-tooltip.hover
              class="pull-up"
              :title="data.item.contacts[c].displayName"
              :text="avatarText(data.item.contacts[c].displayName)"
              :src="
                data.item.contacts[c].profilePic ? data.item.contacts[c].profilePic.small : null
              "
            />
          </b-avatar-group>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <div class="d-flex">
          <b-badge
            pill
            v-b-tooltip.hover.top="
              data.item.uid
                ? 'Er is een Tapp-gebruiker gekoppeld ✅'
                : 'Er is nog geen Tapp-gebruiker gekoppeld 😢'
            "
            :variant="`light-${resolveUserStatusVariant(
              data.item.uid ? 'active' : 'inactive'
            )}`"
            class="text-capitalize"
          >
            {{ data.item.uid ? "actief" : "inactief" }}
          </b-badge>
          <img height="20" v-b-tooltip.hover.top="'Deze gebruiker heeft een Microsoft 365 (Teams) account'" class="ml-50" v-if="data.item.m365" src="data:image/svg+xml;base64,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" />
          </div>
        </template>
        <template #cell(actions)="data">
          <user-dropdown :small="true" :user="data.item" />
        </template>
      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
          <v-select
              v-model="itemsPerPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50 select-size-sm"
            />
            <span class="text-muted"
              >{{ dataMeta.from }} - {{ dataMeta.to }} van
              {{ dataMeta.of }}</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="itemsPerPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal
      ref="modal-move-users"
      size="lg"
      v-model="moveUsersDialogVisible"
      id="modal-event"
      :title="`Gebruikers toevoegen aan groep`"
    >
       <div class="text-nowrap">
            <v-select
              class="mb-1 select-size-sm"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              placeholder="Kies een groep"
              v-model="selectedGroups"
              :options="$store.state.groups"
              transition=""
              :multiple="true"
              :close-on-select="false"
              :getOptionLabel="(option) => option.name"
            />
          </div>
          <div class="text-nowrap">
            <v-select
              class="mb-1 select-size-sm"
              v-model="selectedGroupsRole"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              placeholder=""
              :options="groupRoles"
              :clearable="false"
              :getOptionLabel="(option) => getRoleSingular(option)"
            />
          </div>
      <template #modal-footer>
       <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          @click="addUsersToGroups"
          :disabled="loading"
        >
          Opslaan
        </b-button>
        <b-button
          variant="outline-secondary"
          type="reset"
          @click="moveUsersDialogVisible = false"
          :disabled="loading"
        >
          Annuleren
        </b-button></template>
    </b-modal>
    <b-modal
    hide-footer
    v-model="showUserCreate">
      <user-create @input="userAdded" />
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BAvatarGroup,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BSpinner,
  BPagination,
  VBTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import mainMixin from "@/mixins/mainMixin";

import UserCreate from '../users-create/UserCreate.vue'

import UserDropdown from '../user-dropdown/UserDropdown.vue';
import AdvancedDropdown from '../user-dropdown/AdvancedDropdown.vue';
import DownloadDropdown from '../user-dropdown/DownloadDropdown.vue';
import M365Dropdown from '../user-dropdown/M365Dropdown.vue';

import UsersListFilters from './UsersListFilters.vue';

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import Ripple from 'vue-ripple-directive'

import { db, functions } from '@/firebase/firebaseConfig';


export default {
  mixins: [mainMixin],
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BAvatarGroup,
    BLink,
    BSpinner,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,
    vSelect,
    FeatherIcon,
    UserCreate,
    UserDropdown,
    AdvancedDropdown,
    DownloadDropdown,
    M365Dropdown,
    UsersListFilters
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple
  },
  data() {
    return {
      loading: false,
      moveUsersDialogVisible: false,
      showUserCreate: false,
      searchQuery: "",
      loadingList: false,
      loadingAdvanced: false,
      selected: [],
      selectedGroups: [],
      selectedGroupsRole: 'member',
      itemsPerPage: 25,
      currentPage: 1,
      isMounted: false,
      perPageOptions: [10, 25, 50, 100],
      tableColumns: [
        { key: "selected", label: "" },
        { key: "displayName", label: "Naam", sortable: true },
        { key: "groupIds", label: "Groepen", sortable: true },
        { key: "type", sortable: false },
        { key: 'contacts', label: 'Contacten', sortable: true},
        { key: "status", sortable: false },
        { key: "actions", label: "Acties", sortable: false },
      ],
      totalUsers: 0,
      roleFilter: null,
      groupFilter: [],
      statusFilter: null,
      parentStatusFilter: null,
      statusOptions: [
        {label: "Actief", value: 'active'},
        {label: "Inactief", value: 'inactive'}
      ],
      parentStatusOptions: [
        {label: "Actieve ouders", value: 'active'},
        {label: "Geen actieve ouders", value: 'inactive'}
      ],
      sortBy: "displayName",
      isSortDirDesc: false,
      matchedContacts: {},
      refUserListTable: this.$refs["refUserListTable"],
    };
  },
  computed: {
    totalusers() {
      return this.$store.state.userManagement.users.length;
    },
    selectedUsers(){
      return this.$store.state.userManagement.users.filter((u) => this.selected.includes(u.uoid));
    },
    groupOptions(){
      if(this.$store.state.groups){
        var res = [
          {label: 'Alle', value: 'all'},
          {label: 'Geen', value: 'none'}
        ];
        this.$store.state.groups.forEach(g => {
          res.push({label: g.name, value: g.id});
        });
        return res;
      }else return [];
    },
    orgId() {
      if (this.$store.state.organisation) {
        return this.$store.state.organisation.id;
      } else {
        return null;
      }
    },
    usersData() {
      return this.filterUsers(this.matchContacts(this.$store.state.userManagement.users));
      
    },
    dataMeta() {
      const localItemsCount =
        this.refUserListTable && this.refUserListTable.value
          ? this.refUserListTable.value.length
          : 0;

      var to = this.itemsPerPage * this.currentPage + localItemsCount;
      if (this.totalUsers != 0 && to > this.totalUsers) {
        to = this.totalUsers;
      }

      return {
        from:
          this.itemsPerPage * (this.currentPage - 1) +
          (localItemsCount ? 1 : 0) +1,
        to: to,
        of: this.totalUsers,
      };
    },
  },
  watch: {
    roleFilter(n, o){
      if(n != o){
        this.refetchData();
      }
    },
    statusFilter(n, o){
      if(n != o){
        this.refetchData();
      }
    },
    parentStatusFilter(n, o){
      if(n != o){
        this.refetchData();
      }
    },
    groupFilter(n, o){
      if(n != o){
        this.refetchData();
      }
    }
  },
  methods: {
    avatarText: avatarText,
    getGroupsForUser(uoid){
      var res = {};
      var u = this.usersData.filter((u) => u.uoid == uoid)[0];
      if(u && u.groups){
         for(var k in u.groups){
        var g = u.groups[k];
        if(g && g.organisation == this.$store.state.organisation.id && this.getGroupActive(this.$store, k)){
          res[k] = g;
        }
      }
      } else {
        console.log(uoid);
      }
     
      return res;
    },
    userAdded(res){
      this.showUserCreate = false;
      this.refetchData();
      this.$router.push({name: 'users-edit', params: {
        uoid: res.uoid
      }})
    },
    refetchData() {
      if(this.refUserListTable){
        this.refUserListTable.refresh();
      }
    },
    selectAll() {
      if (this.selected.length === this.totalusers) {
        this.selected = [];
      } else {
        this.selected = this.filterUsers(this.$store.state.userManagement.users).map((a) => a.uoid);
      }
    },
    addUsersToGroups(){
      this.selectedGroups.forEach((g) => {
        this.$store.dispatch('userManagement/addUsersToGroup', {
          orgId: this.$store.state.organisation.id,
            groupId: g.id,
            users: this.selectedUsers,
            role: this.selectedGroupsRole
        })
      })
      this.moveUsersDialogVisible = false;
      this.selected = [];
    },
    Test(){
      // functions
      //     .httpsCallable("getNumberOfPhotosForOrganisation")({orgId: this.$store.state.organisation.id})
      //     .then(async (res) => {
      //       console.log(res);
      //     });
      functions
          .httpsCallable("addUserIdsToPosts")({orgId: this.$store.state.organisation.id})
          .then(async (res) => {
            console.log(res);
          });
    },
    fixContacts(){
      functions
          .httpsCallable("fixDuplicateContacts")({orgId: this.$store.state.organisation.id})
          .then(async (res) => {
            console.log(res);
          });
    },
    fixGroups(){
      
      functions
          .httpsCallable("fixDeletedGroups")({orgId: this.$store.state.organisation.id})
          .then(async (res) => {
            console.log(res);
          });
    },
    fetchUsers(ctx, callback) {
      if (
        this.$store.state.userManagement.users &&
        this.$store.state.userManagement.users.length > 1
      ) {
        if (
        this.$store.state.userManagement.contacts &&
        this.$store.state.userManagement.contacts.length > 1
      ) {
        callback(this.matchContacts(this.pageUsers(this.usersData)));
      } else {
         this.$store
          .dispatch(
            "userManagement/fetchAllContacts",
            this.$store.state.organisation.id
          )
          .then(() => {
            callback(this.matchContacts(this.pageUsers(this.usersData)));
          })
      }
      } else {
        this.$store
          .dispatch(
            "userManagement/fetchUsers",
            this.$store.state.organisation.id
          )
          .then(() => {
           if (
        this.$store.state.userManagement.contacts &&
        this.$store.state.userManagement.contacts.length > 1
      ) {
        callback(this.matchContacts(this.pageUsers(this.usersData)));
      } else {
         this.$store
          .dispatch(
            "userManagement/fetchAllContacts",
            this.$store.state.organisation.id
          )
          .then(() => {
            callback(this.matchContacts(this.pageUsers(this.usersData)));
          });}
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    

    pageUsers(users){
       return users.slice(this.dataMeta.from-1, this.dataMeta.to);
    },
    filterUsers(users) {
      if(this.roleFilter){
        users = users.filter(u => u.type == this.roleFilter);
      }
      if(this.statusFilter && this.statusFilter == 'active'){
         users = users.filter(u => u.uid != undefined);
      }
      if(this.statusFilter && this.statusFilter == 'inactive'){
         users = users.filter(u => u.uid == undefined);
      }
      if(this.parentStatusFilter && this.parentStatusFilter == 'active'){
         users = users.filter(u => u.contacts != null && u.contacts.length > 0);
      }
      if(this.parentStatusFilter && this.parentStatusFilter == 'inactive'){
         users = users.filter(u => u.contacts == null ||  u.contacts.length == 0);
      }
      if(this.groupFilter && this.groupFilter.length > 0){
        if(this.groupFilter.includes('all')){
          users = users.filter(u => u.groupIds != null && u.groupIds.length > 0);
        } else if(this.groupFilter.includes('none')){
          users = users.filter(u => u.groupIds == null || u.groupIds.length == 0);
        } else {
          users = users.filter(u => u.groupIds != null && u.groupIds.some((r) => this.groupFilter.includes(r)));
        }
        
      }
      var sortOrder = 1;
      if(this.isSortDirDesc) sortOrder = -1;
      users.sort((a,b) => ((a[this.sortBy] > b[this.sortBy]) ? 1 : ((b[this.sortBy] > a[this.sortBy]) ? -1 : 0))*sortOrder);
      users = this.searchArray(users, this.searchQuery);
      this.totalUsers = users.length;
      return users;
    },
    
    compare(a, b, field) {
      if (a[field] < b[field]) {
        return -1;
      }
      if (a[field] > b[field]) {
        return 1;
      }
      return 0;
    },
    matchContacts(users) {
      users.forEach((u) => {
        u.contacts = this.$store.state.userManagement.contacts.filter(e => e.children.includes(u.uoid))
        
      });
      return users;
    },
    
  },
  mounted() {
    this.refUserListTable = this.$refs["refUserListTable"];
    this.$watch(
      (vm) => [vm.currentPage, vm.itemsPerPage, vm.sortBy, vm.isSortDirDesc],
      (val) => {
        this.refetchData();
      },
      {
        immediate: true, // run immediately
        deep: true, // detects changes inside objects. not needed here, but maybe in other cases
      }
    );
  },
  beforeDestroy() {
    // this.unwatch();
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
